export default function RequiredAsterisk() {
  return <span className="text-red-500">*</span>;
}
